import { IconProps } from "~/design-system/types";

export function CloseEyeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.76069 14.3667C9.18569 13.7927 8.83569 13.0127 8.83569 12.1377C8.83569 10.3847 10.2477 8.97168 11.9997 8.97168C12.8667 8.97168 13.6647 9.32268 14.2297 9.89668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1049 12.6987C14.8729 13.9887 13.8569 15.0067 12.5679 15.2407"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.65463 17.4722C5.06763 16.2262 3.72363 14.4062 2.74963 12.1372C3.73363 9.85823 5.08663 8.02823 6.68363 6.77223C8.27063 5.51623 10.1016 4.83423 11.9996 4.83423C13.9086 4.83423 15.7386 5.52623 17.3356 6.79123"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4477 8.99072C20.1357 9.90472 20.7407 10.9597 21.2497 12.1367C19.2827 16.6937 15.8067 19.4387 11.9997 19.4387C11.1367 19.4387 10.2857 19.2987 9.46765 19.0257"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.887 4.24951L4.11304 20.0235"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function OpenEyeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Iconly/Light/Show">
        <g id="Show">
          <path
            d="M15.1614 12.0531C15.1614 13.7991 13.7454 15.2141 11.9994 15.2141C10.2534 15.2141 8.83838 13.7991 8.83838 12.0531C8.83838 10.3061 10.2534 8.89111 11.9994 8.89111C13.7454 8.89111 15.1614 10.3061 15.1614 12.0531Z"
            fillRule="evenodd"
            clipRule="evenodd"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.998 19.355C15.806 19.355 19.289 16.617 21.25 12.053C19.289 7.48898 15.806 4.75098 11.998 4.75098H12.002C8.194 4.75098 4.711 7.48898 2.75 12.053C4.711 16.617 8.194 19.355 12.002 19.355H11.998Z"
            fillRule="evenodd"
            clipRule="evenodd"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}
